import React from 'react';

import { Box, Paper, Stack, Text, Title, UnstyledButton } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { useGLMCardStyles } from '../styles';
import { FormValues } from '../types';

const ATHLETE_STATUSES = ['Prospect', 'Visitor', 'Trial', 'Non-Paying Member', 'Member', 'Alumni'];

interface IKiloGLMAthleteStatusSelectProps {
  form: UseFormReturnType<FormValues, (values: FormValues) => FormValues>;
}

const KiloGLMAthleteStatusSelect = ({ form }: IKiloGLMAthleteStatusSelectProps): JSX.Element => {
  const { classes, cx } = useGLMCardStyles();

  return (
    <Paper>
      <Stack sx={{ paddingTop: '20px' }}>
        <Title order={3}>Select New Athlete Status</Title>
        <Text size={15}>
          Select the athlete status that triggers the flow when an athlete is moved to it.
        </Text>
        <Stack spacing={6}>
          {ATHLETE_STATUSES.map(status => {
            const isSelected = form.values.athleteStatus === status;
            return (
              <UnstyledButton key={status} onClick={() => form.setFieldValue('athleteStatus', status)}>
                <Box className={cx(classes.card, { [classes.cardSelected]: isSelected })}>
                  <Text weight={isSelected ? 600 : 400}>{status}</Text>
                </Box>
              </UnstyledButton>
            );
          })}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default KiloGLMAthleteStatusSelect;
